export default "/images/2c63cbf97206d52f3029a6194be6d181.avif";